import React from 'react';
import CartData from './cartData'
import { connect } from 'react-redux'
import { InHomeUtils } from './../../../src/util/inhomeUtils'
import * as cartActions from './../../action/cart'
import { updateSCTags } from './../../service/dtmTag';
import { updateVzdlSCCustomEvent, tempVzdlSCData } from './../../service/vzdl';
import $ from 'jquery';
import styled from 'styled-components'; 
import DowncaretIcon from '@vds/icons/down-caret';
import UpcaretIcon from '@vds/icons/up-caret';

const StyledAmt = styled.section`
span{
    font-size: 22px !important;
    font-weight:400 !important;
}
{
    display:inline;
}
`;

class CartJSON extends React.PureComponent {
    constructor(props) {
        super(props);
        this.cartUpdated = "cart-update";
        this.isDoFlowScrollTop = true;
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
        this.isMonarch = this.props?.isMonarch ? this.props.isMonarch : this.props.buildProductState?.isMonarchView;
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.buildProductState.isReskin !== this.props.buildProductState.isReskin){
            this.isReskin = nextProps.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
        }
    }
    
    handleKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.onCartClick(e);
        }
    }
    onCartClick = () => { 
        if (!this.props.cart.isCartOpen) {
            updateSCTags("cart open");
            if(window && window.location && window.location.pathname && window.location.pathname.includes('buildproducts')){
                tempVzdlSCData.name = "buildproducts";
                updateVzdlSCCustomEvent("cartView", "cartView", "name");
            }
            else if(window && window.location && window.location.pathname && window.location.pathname.includes('checkout')){
                tempVzdlSCData.name = "checkout";
                updateVzdlSCCustomEvent("cartView", "cartView", "name");
            }
            else{
                updateVzdlSCCustomEvent("cartView", "cartView", "");
            }
        }
        else {
            updateSCTags("cart close");
            cartActions.splitBillTab(0, this.props.dispatch)
        }
        cartActions.cartToggle("", this.props.dispatch, this.props.appState.visitId,this.props.buildProductState)
        if (this.props.appState.mobileHelpReveal) {
            cartActions.mobileHelpReveal(this.props.appState.mobileHelpReveal, this.props.dispatch);
        }
    }
    render() {
        let TotalPrice = "$0";
        let OneTimePrice = "0";
        let isNCMVAppFlow = this.props.signIn?.isNCMVAppFlow ?? false;
        let cartClass = `${this.isMonarch ? 'text-black' : 'text-white'} text-normal text-right small-padding-vert-zero small-padding-top-zero tiny-padding-vert-micro tiny-padding-top-medium bold block relative`;

        if(isNCMVAppFlow == true){
            cartClass = cartClass + " mvapp-cart-checkout";
        }

        if (InHomeUtils.isNotNull(this.props.cart.cartHeader) && this.props.cart.cartHeader.length > 0) {
            TotalPrice = this.props.cart.cartHeader[0].monthlyRcPrice !== null ? this.props.cart.cartHeader[0].monthlyRcPrice : TotalPrice;
            if (this.cartUpdated === "cart-update")
                this.cartUpdated = "";
            else if (this.props.appState && InHomeUtils.isNotNull(this.props.appState.currentPage) && InHomeUtils.isNotNull(this.props.appState.currentPage.pathname) && this.props.appState.currentPage.pathname.indexOf('buildproduct') > -1 && this.cartUpdated === "" && this.props.appState.isLoader.loaderCount === 0 && this.props.cart.isCartUpdated) {
                this.cartUpdated = "cart-update";
                setTimeout(() => {
                    this.props.dispatch({ type: 'ISCARTUPDATED', value: false });

                }, 1000);
            }
            if (this.isDoFlowScrollTop && this.props.lqState.doFlowDetails.isDoFlow && this.props.lqState.doFlowDetails.DOIDValue) {
                setTimeout(() => {
                    $('html, body').scrollTop(0);
                    this.isDoFlowScrollTop = false;
                }, 0);
            }
        }
        if (InHomeUtils.isNotNull(this.props.cart.cartHeader) && this.props.cart.cartHeader.length > 0) {
            if (InHomeUtils.isNotNull(this.props.cart.cartData) && this.props.cart.cartData.length > 0 && InHomeUtils.isNotNull(this.props.cart.cartData[0].oneTimeCharge) && InHomeUtils.isNotNull(this.props.cart.cartData[0].oneTimeCharge.onetimecharge)) {
                this.props.cart.cartData[0].oneTimeCharge.onetimecharge.map((obj) => {
                    if (InHomeUtils.isNotNull(obj.price) && obj.price !== "Included" && InHomeUtils.isNotNull(obj.bundleActucalPrice)) {
                        if (InHomeUtils.isNotNull(obj.maxInstallments)) {
                            if (obj.maxInstallments === 1) {
                                let price = obj.price;
                                price = price.substring(1, price.length);
                                OneTimePrice = parseFloat(OneTimePrice) + (parseFloat(price) || 0);
                            }
                            else {
                                OneTimePrice = parseFloat(OneTimePrice) + (parseFloat(obj.bundleActucalPrice) || 0) ;
                            }
                        }
                    }
                });
            }
        }
        const oneTimePrice_Float = parseFloat(OneTimePrice);  // to avoid $NaN being displayed in cart container
        OneTimePrice = oneTimePrice_Float ? "$" + oneTimePrice_Float.toFixed(2) : '$0.00' ; // to avoid $NaN being displayed in cart container
        let cartData = "";
        if (this.props.cart.isCartOpen) {
            if (InHomeUtils.isNotNull(this.props.cart.cartData)) {
                cartData = (this.props.appState.flowType !=='SUPP')  ? '': <CartData />
                //For NC flow cart file moved to verizonLogo.js file, please reffer the page.
            } else {
                this.props.cart.isCartOpen = false;
            }
        }
        const reskinCartChanges = this.isReskin && window.reskinCartChanges === "Y" ? true : false;
        const hideOTCMVMiniCartRskn = this.props?.appState?.flowType ==='MV';        return (
            <div>
                <div className={(TotalPrice.indexOf("$0") > -1 && !(this.props.lqState && this.props.lqState.hoaFlowDetails && this.props.lqState.hoaFlowDetails.isHoaFlow)  && !( this.props.cart && this.props.cart.cartData && this.props.cart.cartData.length > 0 && this.props.cart.cartData[0] && this.props.cart.cartData[0].serviceHeaders && this.props.cart.cartData[0].serviceHeaders.length != 0)) || (this.props.appState.flowType==='MV' && this.props.buildProductState.movesstickyheaderfooter) ? "hide" : ""} id="cartmaindiv" >
                    {/* <ul> */}
                        <div className="more left inline-block topnav_cart" id="Billcart">
                            <div id="BillCartTop" aria-expanded={this.props.cart.isCartOpen?"true":"false"} role="button" tabIndex="0" onClick={(e) => this.onCartClick(e)} onKeyDown={(e) => this.handleKeyDown(e)} className={"pointer " + this.cartUpdated}>
                                <div className={cartClass} data-final-cart="" aria-hidden="false" id="totalAmt" data-cs-mask>
                                {!this.isReskin && <><b data-cart-value="">{TotalPrice}</b>/mo.</> }
                                {/* Updating fontSize of StyledAmt to 22px to fix overlapping issues in mobile */}
                                    {this.isReskin && <StyledAmt><span className="totalamt">{TotalPrice}/mo.</span></StyledAmt>}
                                <span className={`verizon-icons small Icon--shopping-bag ${this.isMonarch ? 'text-black' : 'text-white'} middle`} id="shop" aria-hidden="true"></span><span className={this.props.cart.isCartOpen?"vzicon smallChevron cart-icon icon-chevron-up":"vzicon smallChevron cart-icon icon-chevron-down"} id="shop" aria-hidden="true"></span>
                                {reskinCartChanges && <span className='padding-left-micro'>
                                    { this.props.cart?.isCartOpen ? (<DowncaretIcon color="#FFFFFF" size="medium" /> ) : (<UpcaretIcon color="#FFFFFF" size="medium" /> )}
                                     </span>}
                                    <span className="updateText" aria-hidden="true">Cart Updated</span>
                                    <div className="text-black text-right normal-weight text-small onetime" id="PlusText1" aria-hidden="false"></div><div className={(OneTimePrice === '$0' || OneTimePrice === '$0.00' || hideOTCMVMiniCartRskn ) ? 'hide' : 'text-black text-right text-small normal-weight tiny-padding-vert-micro'} id="PlusText2">Plus <strong>{OneTimePrice}</strong> one-time charges</div>
                                </div>
                            </div>
                            <div id="divTryMeOfferText" className="text-black text-small text-right normal-weight hide">Price starting month 3</div>

                            {cartData}
                        </div>
                    {/* </ul> */}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        appState: state.app,
        buildProductState: state.buildProduct,
        cart: state.cart,
        signIn: state.signIn
    }
}

export default connect(
    mapStateToProps,
)(CartJSON);